import { z } from "zod";
import { ColumnKey, SortableColumnKey } from "./-hooks/useColumns";

export const SearchSchema = z.object({
  freeText: z.string().optional(),
  // アプリの一覧でアプリを指定して検索はしない。（人の一覧で人のフィルタを作るようなもの）
  // appIdIn: z.array(z.string()).optional(),
  categoryIn: z.array(z.string()).optional(),

  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  sortColumn: z.enum(SortableColumnKey).default(ColumnKey.count30Days),
  sortOrder: z.enum(["asc", "desc"]).default("desc"),
});

export type SearchParams = z.infer<typeof SearchSchema>;
